import { Component } from 'react';


class Presentazione extends Component {

    render(){
        return (

            <div class="container-fluid text-light" id="presentazione">
                <div class="containerfoto">
                    <h5 class="card-title display-5">Formaggeria E...</h5>
                    <p class="card-text display-3 text-sm-left">Az. Agricola Scrofani Giorgio</p>
                    <p class="card-text display-6"><small>San Giacomo, Ragusa</small></p>
                
            </div>
            </div>
            
            
        );
    }

}

export default Presentazione;